/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.Inventory {

    import fld = MaterialReceiptItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MaterialReceiptItemsEditor extends _Ext.ItemGridEditor<MaterialReceiptItemsRow> {


        protected getColumnsKey() { return "Inventory.MaterialReceiptItems"; }
        protected getDialogType() { return MaterialReceiptItemsDialog; }
        protected getLocalTextPrefix() { return MaterialReceiptItemsRow.localTextPrefix; }
        protected form: MaterialReceiptItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public DeptId: number; 
        public isUpdate: number;
        public canUpdate: number;
        public MasterEntity: any;
        public VoucherTypeId: number;
        isEditable: boolean;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as MaterialReceiptDialog).CalculateAmountandTax(this.view.getItems() );
                }
            })
        }
        setMasterValues() {
            this.RateListId = (this.parentDialog as MaterialReceiptDialog).RateListId;
            this.LaborListId = (this.parentDialog as MaterialReceiptDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as MaterialReceiptDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as MaterialReceiptDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as MaterialReceiptDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as MaterialReceiptDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as MaterialReceiptDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as MaterialReceiptDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as MaterialReceiptDialog).form.PartyId.value);
            this.VoucherTypeId = (this.parentDialog as MaterialReceiptDialog).form.VoucherTypeId.value;
        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            Q.first(columns, x => x.field === fld.Pieces).format = ctx => {
                if (ctx.item.ItemTypeId != 104)
                    return this.isReadOnly == false ? ColumnFormatter.integerInputFormatter(ctx, this) : ColumnFormatter.ReadOnlyIntegerInput(ctx, this);
                else
                    return this.isReadOnly == false ? ctx.item.CategoryId != "7" ? ColumnFormatter.ReadOnlyIntegerInput(ctx, this) : ColumnFormatter.integerInputFormatter(ctx, this) : ColumnFormatter.ReadOnlyIntegerInput(ctx, this);
            }

            Q.first(columns, x => x.field === fld.Weight).format = ctx => {
                if (ctx.item.ItemTypeId == 101 && ctx.item.HasBom)
                    return ColumnFormatter.ReadOnlyWeightFormatter(ctx, this);
                else
                    return this.isReadOnly == false ? ColumnFormatter.WeightFormatter(ctx, this) : ColumnFormatter.ReadOnlyWeightFormatter(ctx, this);
            }

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion
         
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                         
                        this.view.deleteItem(id);
                        //}

                    });
                    this.view.refresh();
                    (this.parentDialog as MaterialReceiptDialog).CalculateAmountandTax(this.view.getItems());

                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as MaterialReceiptDialog).CalculateAmountandTax(this.view.getItems());

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.ProductSelectGrid;
            buttons = buttons.filter(x => x.cssClass != "add-button");


            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            FilterItems: TabAurous.ItemSelection.S,
                            IsCustomerItem: true
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2: OMS.ProductMasterRow[] = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var self = this;
                        //alert('Length' + selectedItems.length); 
                        for (var i = 0; i < selectedItems2.length; i++) {
                            var DeptId = 0;
                            let Line_No;
                            var Item = selectedItems2[i];
                            var VoucherDetails = Q.first(OMS.VoucherMasterRow.getLookup().items, x => x.VoucherTypeId == self.VoucherTypeId);
                            switch (Item.ItemTypeId) {
                                case 101:
                                    DeptId = VoucherDetails.DefaultJewelleryDepartment;
                                    break;
                                case 104:
                                    DeptId = VoucherDetails.DefaultMetalDepartment;
                                    break;
                                case 105:
                                    DeptId = VoucherDetails.DefaultStoneDepartment;
                                    break;
                            }
                            var item: MaterialReceiptItemsRow = {
                                ProductId: Item.ProductId,
                                AttributeId: Item.AttributeId,
                                Attribute: Item.Attribute,
                                Line_No: 0,
                                PartyId: self.PartyId,
                                SKU: "0",
                                DepartmentId: DeptId,
                                ProductCode: Item.ProductCode,
                                ProductName: Item.ProductName,
                                ItemTypeId: Item.ItemTypeId,
                                HasBom: Item.HasBom,
                                CategoryId: Item.CategoryId,
                                ProductTypeId: Item.ProductTypeId,
                                SubCategoryId: Item.SubCategoryId,
                                UnitRate: Item.Rate,
                                Pieces: Item.Pieces >= 0 ? Item.Pieces : 1,
                                Weight: Item.Weight == undefined ? 0 : Item.Weight,
                                NetWeight: Item.Weight,
                                NetAmount: 0,
                                GrossAmount: 0,
                                CalcOnId: Item.CalcOnId,
                                CompanyId: Q.Authorization.userDefinition.CompanyId,
                                HSN: Item.HSN,
                                TaxCode: Item.TaxCode,
                                MetalId: Item.MetalId,
                                KaratId: Item.ItemTypeId == 101 ? Item.KaratId : Item.KaratId,
                                MetalColorId: Item.MetalColorId,
                                QualityId: Item.QualityId,
                                SieveId: Item.SieveId,
                                ShapeId: Item.ShapeId,
                                StoneColorId: Item.StoneColorId,
                                StoneSizeId: Item.StoneSizeId,
                                Studded: 0, // marking item as bulk
                                StoneCutId: Item.StoneCutId,
                                StonePolishId: Item.StonePolishId,
                                StoneSymmetryId: Item.StoneSymmetryId,
                                StoneFluorescenceId: Item.StoneFluorescenceId,
                                StoneCuletId: Item.StoneCuletId,
                                StoneGirdleId: Item.StoneGirdleId,
                                StoneTable: Item.StoneTable,
                                StoneDepth: Item.StoneDepth,
                                StoneSizeName: Item.StoneSizeName,
                                ShapeName: Item.ShapeName,
                                GroupSieveName: Item.GroupSieveName,
                                QualityName: Item.QualityName,
                                StoneColoreName: Item.StoneColoreName,
                                SieveName: Item.SieveName,
                                Purity: Item.Purity,
                                LotNo: FormatHelper.GetFormats("Lot"),
                                CalcUnitId: Item.CalcUnitId,
                                PureWeight: 0,
                                RefVoucherId: 0,
                                RefTransId: 0,
                                RefTransItemId: 0,
                                IsConfigurable: selectedItems2[i].IsConfigurable,
                                IsCustomerItem: selectedItems2[i].IsCustomerItem,
                                StockAllocation: false
                            }
                            item[this.getIdProperty()] = "`" + this.nextId++;

                            this.view.addItem(item);
                        }
                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });
            ItemGridHelper
            return buttons;

        }



        // #endregion


    }
}